/** @format */

import {Box, Typography} from '@mui/material';
import {styled} from '@mui/system';

export const WidgetContainer = styled(Box)(({theme}) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(4),
  width: '100%',
  height: '150px',
  padding: theme.spacing(4),
  backgroundColor: theme.palette.semantic_dark?.surface.surface1,
  borderRadius: '12px',
}));

export const LoaderWrapper = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
});

export const ChartContainer = styled(Box)({
  width: '100%',
  position: 'relative',
});

export const ChartWrapper = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  height: '100%',
});

export const LabelText = styled(Typography)(({theme}) => ({
  color: theme.palette.semantic_dark?.surface.onSurface,
  fontSize: '20px',
  fontWeight: 500,
  lineHeight: '22px',
  letterSpacing: '0.2px',
}));
